export class Address {
    public BuildingName: string;
    public BuildingNo: string;
    public City: string;
    public CitySubdivision: string;
    public Country: string;
    public Description: string;
    public District: string;
    public DoorNumber: string;
    public Email: string;
    public Fax: string;
    public PostalZone: string;
    public Street: string;
    public Town: string;
    public Website: string;
    public WorkPhoneNumber: string;
}